<template>
  <div class="wrapper" ref="wrapper">
    <div class="header-wrapper">
      <switch-tab
        :arr="arrtab"
        :selectIndex="selectIndex"
        @changeTab="changeTab"
        :isLoading="isLoading"
      ></switch-tab>
      <div class="header">活动管理</div>
      <div class="addManager">
        <Button class="bkcc-btn" @click="newActivity()">新建活动</Button>
      </div>
    </div>
    <div v-if="noActivity" class="no-activity"></div>
    <activity-card v-else
      :activityList="activityList"
      :isCaogao="selectIndex"
      @init="initList"
    ></activity-card>
    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import switchTab from "../components/switchTab";
import activityCard from "../components/activityCard";

var that;
export default {
  name: "activitylist",
  //import引入的组件需要注入到对象中才能使用
  components: {
    switchTab,
    activityCard
  },
  data() {
    //这里存放数据
    return {
      infiniteId:+new Date(),
      total: "-1",
      arrtab: ["活动", "草稿"],
      filterList: [],
      activityList: [],
      noActivity: false,
      page: 1,
      pageSize: 10,
      selectIndex: 0, // tabIndex 1为草稿 0为发送
      tabClick: true,
      changetab: "",
      isLoading: false,
      communityId: parseInt(this.$store.state.streetorcommunityid),
      title: "",
      communityIdList: [],
      onShowFlag: false // 缓存页面的onshow
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    /* 当前total发生变化时 右侧label显示跟着变化 */
    total(newVal) {
      this.$store.commit("updateLabelList", [
        {
          name: "filter_label",
          data: {
            label: "当前总数",
            value: newVal
          }
        }
      ]);
    }
  },
  //方法集合
  methods: {
    infiniteHandler($state){
      this.getList($state);
    },
    changeTab(index) {
      //切换发送和草稿  1为草稿 0为发送
      this.selectIndex = index
      this.page = 1;
      this.activityList = [];
      this.infiniteId += 1;
      that.filterList = [];
      that.getfilter();
    },
    //打开新增活动页面
    newActivity() {
      this.$router.push({
        name: "newactivity",
        query: { state: this.selectIndex }
      });
    },
    /* 初始化筛选列表 */
    initFilterList(list) {
      /* search 数据 */
      let search = {
        name: "search",
        data: {},
        event: function(e) {
          that[e.fn](e);
        }
      };
      list.unshift(search);
      this.$store.commit("updateFilterList", list);
    },
    getList(loadingContext){
      if (this.isLoading) return;

      this.isLoading = true;
      var url = that.urlobj.getActivity;
      this.$post(url, {
        pageNum: that.page,
        pageSize: this.pageSize,
        isSend: this.selectIndex ==1 ? 0:1,//后端 isSend0草稿，1为活动，前端selectIndex:1为草稿0为活动
        communityIdList: that.communityIdList,
        recentDay: -1, // 代表全部
        title: this.title
      }).then(res => {
       this.isLoading = false;

        var list = res.rows.map(item => ({
          activeFlag: this.handleTime(item.beginTime, item.endTime).activeFlag,
          cnstate: this.handleTime(item.beginTime, item.endTime).cnstate,
          state: 1,
          id: item.id,
          coverPicUrl: item.coverPicUrl,
          title: item.title,
          previewNumber: item.previewNumber,
          messageNumber: item.messageNumber
        }));

        that.activityList = that.activityList.concat(list);

       if (this.page == 1) that.total = res.total;
        /* 如果没有数据 显示占位图 */
        if (that.activityList.length == 0){
            this.noActivity = true;
        }else{
            this.noActivity = false;
        } 

        if (res.rows.length < 10) {
          loadingContext.complete();
          //加载完成 可以点击切换
        } else {
          this.page += 1;
          
          loadingContext.loaded(); // 结束加载状态
        }
      });
    },
    handleTime(beginTime, endTime) {
      if (Date.now() > new Date(Number(endTime))) {
        return {
          activeFlag: 1,
          cnstate: "已结束"
        };
      } else if (Date.now() < new Date(Number(beginTime))) {
        return {
          activeFlag: 2,
          cnstate: "未开始"
        };
      } else if (
        Date.now() <= new Date(Number(endTime)) &&
        Date.now() >= new Date(Number(beginTime))
      ) {
        return {
          activeFlag: 3,
          cnstate: "进行中"
        };
      }
    },
    initList(num) {
      //撤销或删除后  初始化请求  1为已发送（撤回）  0为草稿（删除）
      that.page = 1;
      that.activityList = [];
      this.infiniteId += 1
      //this.getList()
    },
    getfilter() {
      this.filterList = []; //重置filterlist
      var filterData = [];
      if (this.$store.state.isJiedao == 1) {
        var _url = this.urlobj.getActiveLabel;
        this.$get(_url, {
          isSend: this.selectIndex == 0 ? 1 : 0
        }).then(res => {
          var num = 0;
          var ids = [];
          var counts = [];
          ids = res.rows.map(item => {
            return item.communityId;
          });
          counts = res.rows.map(item => {
            return item.activityCount;
          });
          counts.forEach(item => {
            num += item;
          });
          var item1 = {
            name: "全部",
            id: ids,
            userCount: num
          };
          var list = res.rows.map(item => {
            return {
              name: item.communityName,
              id: [item.communityId],
              userCount: item.activityCount
            };
          });
          list.unshift(item1);
          //匹配默认选中index
          var index1 = -1;
          list.forEach((item, index) => {
            if (item.id == this.$store.state.streetorcommunityid) {
              index1 = index;
            }
          });
          filterData.push({
            type: "community",
            name: "行政区域",
            selectedIndex: 0,
            children: list
          });
          this.communityIdList = list[0].id;
          for (const obj in filterData) {
            this.filterList.push(new FilterItem(filterData[obj]));
          }
          this.initFilterList(this.filterList);
        });
      } else {
        this.initFilterList(this.filterList);
      }
    },
    /* ---------------------所有 筛选 业务处理 代码 如下--------------------*/
    /* 重置筛选列表 */
    _reset() {
      this.title = "";
      this.communityId = this.$store.state.isJiedao
        ? ""
        : parseInt(this.$store.state.streetorcommunityid);
      this.communityIdList = this.$store.state.isJiedao
        ? []
        : [parseInt(this.$store.state.streetorcommunityid)];
      this.page = 1;
      this.activityList = [];
      this.infiniteId += 1

      this.getfilter();
    },
    /* ==================== 搜索  BEGIN==================== */
    search({ params }) {
      this.page = 1;
      this.title = params.searchValue;
      this.activityList = [];
      this.infiniteId += 1
    },
    /* ==================== 搜索  END==================== */
    /* ==================== 行政区域  BEGIN==================== */
    areaChange({ params }) {
      this._groupChange(params);
    },
    /* 勾选筛选 初始化不同的属性*/
    _groupChange(e) {
      let target = this.filterList[e.filterListIndex];

      /* 修改筛选条件 source 传type 其他的传id*/
      if (target.type == "community") {
        this.communityId = target.data.dataList[e.selectedIndex].id;
        this.communityIdList = target.data.dataList[e.selectedIndex].id;
        // this.getfilter();
      }

      this.page = 1;
      this.activityList = [];
      this.infiniteId += 1
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.reset = this._.debounce(this._reset, 500); // filter 重置后会触发
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    that = this;
    this.selectIndex = this.$route.query.state == 0 ? 1 : 0;
    this.getfilter();
    this.getList()
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {
    if (this.onShowFlag) {
      this.page = 1;
      this.activityList.length = 0;

      this.infiniteId += 1
    }
  }, //如果页面有keep-alive缓存功能，这个函数会触发
  deactivated() {
    this.onShowFlag = true;
  }
};

/* ---------------------------筛选组件构造对象 --------------------------*/
/*
    type : 用来确定 使用哪个组件
    name ：组件显示的头部文字
    children: 子列表数据
  */
function FilterItem({ type, name, children, selectedIndex }) {
  /* 如果是来源 获取图片路径 */
  /* 是否可编辑 以后扩展*/
  this.editMode = function(type) {
    switch (type) {
      case "category":
        return true;
      default:
        return false;
    }
  };
  /* 初始化 组件类型 this.name 确定组件类型*/
  switch (type) {
    case "community":
      this.name = "singleDivision";
      break;
  }
  /* 对象类型 */
  this.type = type;
  /* 初始化对象 数据 */
  this.data = {
    title: name, // 解构过来的name
    edit: this.editMode(type),
    dataList: children.map((item, index) => {
      return {
        id: item.id,
        label: item.name,
        number: item.userCount,
        iconPath: "",
        type: item.type || ""
      };
    })
  };
  if (selectedIndex > -1) {
    this.data.selectedIndex = selectedIndex;
  }
  /* 初始化对象事件 写死的 由当前组件对象去处理业务逻辑，没有相关函数会报错*/
  this.event = function(e) {
    that[e.fn](e);
  };
}
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
/* 头部信息 开始 */
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
}

.wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  /* height: 4px; */
}

.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}

.header {
  font-size: 25px;
  text-align: center;
}

.addManager {
  position: absolute;
  right: 20px;
}

.no-activity {
  height: 100%;
  background: url("~@/assets/images/activity_replace.png") 50% 40% no-repeat;
}
</style>
